<template>
  <div>
    <list row-key="id" ref="list" unit="售后订单" :page="page" :query-params="params" :show-query="showQuery"
      :get-data-func="getDataFunc" max-height="600px">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="订单编号" label-width="105px">
          <el-input v-model="params.orderSn" placeholder="请输入订单编号" clearable />
        </el-form-item>
        <el-form-item label="下单时间" label-width="105px">
          <range-picker :date="[params.afterSalesStartDate, params.afterSalesEndDate]"
            @change="x => { params.afterSalesStartDate = x.Start; params.afterSalesEndDate = x.End; }" />
        </el-form-item>
        <el-form-item label="售后状态" label-width="105px">
          <el-select v-model="params.afterSalesStatus" placeholder="请选择" clearable>
            <el-option label="等待卖家同意" value="等待卖家同意"></el-option>
            <el-option label="退款成功" value="退款成功"></el-option>
            <el-option label="退款关闭" value="退款关闭"></el-option>
            <el-option label="待买家修改" value="待买家修改"></el-option>
            <el-option label="等待买家退货" value="等待买家退货"></el-option>
            <el-option label="等待卖家确认收货" value="等待卖家确认收货"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="aliMall.mallName" label="店铺名称" min-width="150px" />
        <el-table-column prop="refundSn" label="售后单号" min-width="200px" />
        <el-table-column prop="afterSalesCreateTime" label="售后创建时间" min-width="160px" />
        <el-table-column prop="afterSaleReason" label="售后原因" min-width="300px" />
        <el-table-column prop="refundFree" label="退款金额" min-width="100px" />
        <el-table-column prop="refundFinishTime" label="售后结束时间" min-width="160px" />
        <el-table-column prop="afterSalesStatus" label="售后状态" min-width="150px" />
        <el-table-column prop="orderSn" label="所属订单" min-width="180px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require('@/api/wx/order').default,
      params: {
        orderSn: "", // 订单编号
        afterSalesStartDate: null, // 下单时间
        afterSalesEndDate: null,
        afterSalesStatus: null, // 售后状态
        isRefund: true, // 是否售后订单
      },
    };
  },
  created() { },
  methods: {
    getDataFunc(params) {
      params = this.$commonJs.obj.removeNullKey(params);
      return new Promise((resolve, reject) => {
        console.log("获取数据", params);
        this.api.getOrders(params).then(res => {
          console.log("getDataFunc", res);
          resolve({ code: 0, data: res.data, count: res.count, msg: null });
        }).catch(err => {
          reject(err);
        })
      })
    },
  },
};
</script>